export enum ProgramDetailsViewTypeEnum {
  Program,
  Class,
}
